import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableInboundTollingAgreement = QueryHookResult<
  typeof useInboundTollingAgreementsQuery
>[number];

export const useInboundTollingAgreementsQuery = createQueryHook(
  'shared.selectInboundTollingAgreement',
  (params: {
    searchTerm?: string;
    ids?: string[];
    isActive?: boolean;
    customerAccountId?: string;
  }) => ({
    inboundTollingAgreements: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          isActive: params.isActive ?? true,
          customerAccountId: params.customerAccountId,
        },
        pagination: {
          offset: 0,
          limit: 20,
        },
      },
      entries: {
        id: true,
        agreementNumber: true,
        customerAccount: {
          id: true,
          name: true,
        },
        processingType: {
          id: true,
          name: true,
        },
        isActive: true,
      },
    },
  }),
  {
    select: (data) => data.inboundTollingAgreements.entries ?? [],
  },
);

export const SelectInboundTollingAgreement =
  createEntityComboBox.remotelySearched(
    'SelectInboundTollingAgreement',
    useInboundTollingAgreementsQuery,
    {
      formatLabel: (entity) =>
        `${entity.agreementNumber} - ${entity.customerAccount?.name ?? 'Unknown'}`,
      formatSubLabel: (entity) => entity.processingType?.name ?? '',
    },
  );
